export const getProductSubscriptionLineOfSubscriptionLines = (subscriptionLines) =>
  subscriptionLines?.find((subscriptionLine) => !subscriptionLine.product.isAddon);

export const getAddonSubscriptionLinesOfSubscriptionLines = (subscriptionLines) =>
  subscriptionLines.filter((subscriptionLine) => subscriptionLine.product.isAddon);
